import PropTypes from 'prop-types';

export const RecipientInfo = PropTypes.shape({
    sellerId: PropTypes.string,
    displayName: PropTypes.string,
    username: PropTypes.string.isRequired,
    profilePhoto: PropTypes.string.isRequired,
    isOnline: PropTypes.bool.isRequired,
    responseTimeInHrs: PropTypes.number.isRequired,
    utcOffset: PropTypes.number,
    countryCode: PropTypes.string,
    proficientLanguages: PropTypes.object,
    offerHourlyRate: PropTypes.bool
}).isRequired;

export const AttachmentsUploadConfig = PropTypes.shape({
    objectName: PropTypes.string,
    attachmentName: PropTypes.string,
    getPolicyUrl: PropTypes.string,
    createPendingAttachmentIdUrl: PropTypes.string
});

export const SenderInfo = PropTypes.shape({
    hasApp: PropTypes.bool,
    isRnc: PropTypes.bool,
    username: PropTypes.string
});

export const BriefInfo = PropTypes.shape({
    categoryId: PropTypes.number,
    subCategoryId: PropTypes.number
});

export const VacationInfo = PropTypes.shape({
    endsAt: PropTypes.number,
    awayMessage: PropTypes.string,
    isContactAllowed: PropTypes.bool
});
